import AGREGAR_DOCUMENTO_RELACIONADO from '@/graphql/mutations/administracion/documentosrelacionados/agregarDocumentoRelacionado.gql';
import ACTUALIZAR_DOCUMENTO_RELACIONADO from '@/graphql/mutations/administracion/documentosrelacionados/actualizarDocumentoRelacionado.gql';
import REMOVER_DOCUMENTO_RELACIONADO from '@/graphql/mutations/administracion/documentosrelacionados/removerDocumentoRelacionado.gql';
import DOCUMENTOS_RELACIONADOS from '@/graphql/querys/administracion/documentosrelacionados/documentosRelacionados.gql';

export default {
  methods: {
    seleccion() {
      if (document.getElementById('anexo').files[0]?.type === 'application/pdf') {
        this.vistaPrevia = true;
      } else {
        this.vistaPrevia = false;
      }
      this.rutaArchivo = URL.createObjectURL(
        document.getElementById('anexo').files[0],
      );
      this.nombreArchivoSeleccionado = document.getElementById('anexo').files[0].name;
    },
    // Agregar Documento Relacionado
    async mixAgregarDocumentoRelacionado() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_DOCUMENTO_RELACIONADO,
        variables: {
          documentoRelacionado: this.documentoRelacionado,
        },
        update: (store, { data: { agregarDocumentoRelacionado } }) => {
          const query = {
            query: DOCUMENTOS_RELACIONADOS,
            variables: {
              idReferencia: this.idReferencia,
            },
          };
          const { documentosRelacionados } = store.readQuery(query);
          const documentosRelacionadosCopia = documentosRelacionados.slice();
          documentosRelacionadosCopia.push(agregarDocumentoRelacionado);
          store.writeQuery({
            ...query,
            data: {
              documentosRelacionados: documentosRelacionadosCopia,
            },
          });
        },
      })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Editar Documento Relacionado
    async mixActualizarDocumentoRelacionado() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_DOCUMENTO_RELACIONADO,
        variables: {
          id: this.documentoRelacionadoEditar.id,
          documentoRelacionado: this.documentoRelacionado,
        },
        update: (store, { data: { actualizarDocumentoRelacionado } }) => {
          const query = {
            query: DOCUMENTOS_RELACIONADOS,
            variables: {
              idReferencia: this.documentoRelacionadoEditar.idReferencia,
            },
          };
          const data = store.readQuery(query);
          const { documentosRelacionados } = data;
          const index = documentosRelacionados
            .findIndex((documentoRelacionado) => documentoRelacionado.id
              === actualizarDocumentoRelacionado.id);
          if (index !== -1) {
            documentosRelacionados.splice(index, 1, actualizarDocumentoRelacionado);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Documento Relacionado
    async mixEliminarDocumentoRelacionado() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_DOCUMENTO_RELACIONADO,
        variables: {
          id: this.documentoRelacionadoEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({
            query: DOCUMENTOS_RELACIONADOS,
            variables: {
              idReferencia: this.idReferencia,
            },
          });
          const { documentosRelacionados } = data;
          const index = documentosRelacionados
            .findIndex((documentoRelacionado) => documentoRelacionado.id
            === this.documentoRelacionadoEliminar.id);
          if (index !== -1) {
            documentosRelacionados.splice(index, 1);
          }
          store.writeQuery({ query: DOCUMENTOS_RELACIONADOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },

};
